import component from "./TeamMedalsReport.js";

export default component;
